module.exports = __webpack_public_path__ + "static/media/academic.4f9c7c9d.png";